import React from "react";

const NoProductsMessage = ({ 
  title = "No Products Found", 
  message = "We couldn't find any products matching your criteria.",
  suggestions = [
    "Adjusting the price range",
    "Removing the rating filter", 
    "Checking different categories",
    "Clearing all filters"
  ]
}) => {
  return (
    <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center min-h-[300px] flex items-center justify-center">
      <div>
        <svg 
          className="w-16 h-16 mx-auto mb-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M20 12H4M12 20V4"
          />
        </svg>
        <h2 className="text-2xl font-semibold text-gray-700 mb-3">{title}</h2>
        <p className="text-gray-500 mb-4">{message}</p>
        <p className="text-gray-500">Try:</p>
        <ul className="text-gray-500 mt-2">
          {suggestions.map((suggestion, index) => (
            <li key={index}>• {suggestion}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NoProductsMessage; 